import { Component } from '@angular/core';
import { Location } from '@angular/common';

import { LayoutService } from '@app/core/services/layout.service';

@Component({
	selector: 'app-page-not-found',
	templateUrl: './page-not-found.component.html',
	styleUrls: ['./page-not-found.component.scss'],
})
export class PageNotFoundComponent {
	constructor(private layoutService: LayoutService, private location: Location) {
		this.layoutService.setPageLoading(false);
	}
}
